import { connect } from 'react-redux';
import { fetchDraft, createDraft, fetchAllTeams, fetchPlayersByName } from '../../actions/actions-index';
import DraftEdit from '../../components/Draft/DraftEdit';
import { reduxForm } from "redux-form";
import * as _ from 'lodash';

function mapStateToProps(state, ownProps) {
    let initValue = null;
    if (ownProps.match.params) {
        initValue = state.draft[ownProps.match.params.id];
    }
    return {
        initialValues: initValue,
        enableReinitialize: true,
        teams: state.team,
        id: ownProps.match.params ? ownProps.match.params.id : '',
    }
}

const validate = values => {
    const errors = {};
    if (!values.year) {
        errors.year = 'Required';
    }
    if (values.rounds) {
        let roundArrayErrors = [];
        values.rounds.forEach((round, roundIndex) => {
            if (round.picks) {
                let pickArrayErrors = [];
                round.picks.forEach((pick, pickIndex) => {
                    //let pickErrors = {};
                    if (pick && pick.details && pick.details.length) {
                        let pickDetailArrayErrors = [];
                        pick.details.forEach((pickDetail, pickDetailIndex) => {
                            let pickDetailErrors = {};
                            if (!pickDetail || !pickDetail.team) {
                                pickDetailErrors.team = 'Required';
                                pickDetailArrayErrors[pickDetailIndex] = pickDetailErrors;
                            }
                        });
                        if (pickDetailArrayErrors.length) {
                            if (!pickArrayErrors[pickIndex]) {
                                pickArrayErrors[pickIndex] = {};
                            }
                            pickArrayErrors[pickIndex].details = pickDetailArrayErrors;
                        }
                    }
                });
                if (pickArrayErrors.length) {
                    roundArrayErrors[roundIndex] = {picks: pickArrayErrors}
                }
            }
        });
        if (roundArrayErrors.length) {
            errors.rounds = roundArrayErrors;
        }
        
    }
    if (!_.isEmpty(errors)) {
        errors._error = 'Error while submitting. Check invalid fields above.';
    }
    return errors;
};

let DraftEditForm = reduxForm({
    // a unique name for the form
    form: 'draftForm',
    validate
})(DraftEdit);

export default connect(
    mapStateToProps,
    {
        fetchDraft,
        createDraft,
        fetchAllTeams,
        fetchPlayersByName,
    }
)(DraftEditForm);



// WEBPACK FOOTER //
// ./src/containers/Draft/DraftEditContainer.js